import React from 'react';
import PropTypes from 'prop-types';
import Product from './Product';
import { connect } from 'react-redux';
const Products = (props) => {

  const productList = Object.values(props.products).map((product, i) => (
    <div key={i} className="slds-size_1-of-1" style={{ padding: '5px' }}>
      <Product
        category={product.category}
        id={product.id}
        size="large"
        productTitle={product.Name}
        index={i}
      />
    </div>
  ));

  return <div className="slds-grid slds-wrap">{productList}</div>;
};

Products.propTypes = {
  products: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  username: state.app.username,
});

export default connect(mapStateToProps)(Products);
